import { createAsyncThunk, createSlice, isPending } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { USER_PLAN_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { PAGE_SIZE } from "utils/CommonConstants";
import { deleteMyPlansAsync } from "../MyPlans/myplans.slice";

const SLICE = "IndividualUser";

export interface UserViewState {
  userDetails: any;
  showIndividualUserLoader?: boolean;
  userSnapshot?: any;
  plans: any;
}

const initialState: UserViewState = {
  showIndividualUserLoader: false,
  userDetails: {},
  userSnapshot: {
    USER_PROPERTY_CARDS_SNAPSHOT: [],
    USER_PROPERTY_PLAN_SNAPSHOT: []
  },
  plans: {
    list: []
  }
};

export const fetchUserDetails = createAsyncThunk(`${SLICE}/fetchUserDetails`, (data: any, thunkApi) =>
  apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data)
);

export const fetchUserViewSnapshot = createAsyncThunk(`${SLICE}/fetchUserViewSnapshot`, (data: any, thunkApi) => {
  const params = { externalHltId: data?.hltId, innCode: data?.innCode };
  return apiRequest(USER_PLAN_SERVICE_METHOD.getAboveProperty, {}, thunkApi, ["user-property", "snapshot"], params);
});

export const fetchPlansAsync = createAsyncThunk(`${SLICE}/fetchPlansAsync`, (data: any, thunkApi) => {
  const params = { page: data?.page, size: PAGE_SIZE };
  return apiRequest(USER_PLAN_SERVICE_METHOD.postAboveProperty, data.payload, thunkApi, ["plans"], params);
});

export const impersonateAudit = createAsyncThunk(`${SLICE}/impersonateAudit`, (data: any, thunkApi) =>
  apiRequest(USER_SERVICES_METHOD.postImpersonationAudits, {}, thunkApi)
);

function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

export const IndividualUserSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState,
    setLoader: (state, action) => {
      state.showIndividualUserLoader = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPlansAsync.pending, (state, action) => {
        if (action?.meta?.arg?.page === 0) state.showIndividualUserLoader = true;
      })
      .addCase(fetchPlansAsync.fulfilled, (state, action) => {
        state.plans.list =
          action.meta.arg.page === 0
            ? action.payload.userplans || []
            : [...state.plans.list, ...action.payload.userplans];
        state.plans.totalList = action.payload?.meta?.page?.total;
        if (!action.payload.userplans) state.showIndividualUserLoader = false;
      })
      .addCase(deleteMyPlansAsync.fulfilled, (state, action: any) => {
        state.plans.list = state.plans.list.filter((plan: any) => plan.id !== action?.meta?.arg?.id);
        state.plans.totalList = state.plans.totalList - 1;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.userDetails = action.payload.users?.[0] || {};
        state.showIndividualUserLoader = false;
      })
      .addCase(fetchUserViewSnapshot.fulfilled, (state, action) => {
        state.showIndividualUserLoader = false;
        state.userSnapshot = action?.payload;
      })
      .addMatcher(isPending(fetchUserDetails, fetchUserViewSnapshot), (state) => {
        state.showIndividualUserLoader = true;
      })
      .addMatcher(isRejectedAction, (state) => {
        state.showIndividualUserLoader = false;
      });
  }
});

export const { reset, setLoader } = IndividualUserSlice.actions;

export default IndividualUserSlice.reducer;
